import { render, staticRenderFns } from "./pedidosTienda.vue?vue&type=template&id=09f6f2ae"
import script from "./pedidosTienda.vue?vue&type=script&lang=js"
export * from "./pedidosTienda.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports